module.exports = __webpack_public_path__ + "img/logo-console.b7cc3314.svg";